export const words = [
  {
    word: "apple",
    tag: "fruit",
    hints: [
      { text: "tech brand", weight: 0.2 },
      { text: "red fruit", weight: 0.5 },
      { text: "doctor away", weight: 0.9 }
    ]
  },
  {
    word: "tiger",
    tag: "animal",
    hints: [
      { text: "striped", weight: 0.4 },
      { text: "big cat", weight: 0.7 },
      { text: "jungle predator", weight: 0.95 }
    ]
  }
];